import React from "react";
import { Header } from "../components/Common/Header";
import { ServiceCard } from "../components/Services/ServiceCard";
import { Parallex } from "../components/Common/Parallax";
import InteractiveTestimonials from "../components/Testimonials/TestimonialCard";
import { PrimaryButton } from "../components/Common/PrimaryButton";
import { Title } from "../components/Common/Title";
import { BlogCard2 } from "../components/Blogs/BlogCard2";
import { Link, useNavigate } from "react-router-dom";

import Book from "../assets/images/book-in-hands.webp";

import Ebooks from "../assets/images/ebooks.webp";

import HomeImage from "../assets/images/Headers/HomeBg.jpg";
import HomeParallex from "../assets/images/Headers/HomeParallex.jpg";


import { trendingblogs } from "../data/Blogs/BlogPosts";
import { SecondaryButton } from "../components/Common/SecondaryButton";
import { OutLineButton } from "../components/Common/OutLineButton";

import {
  CheckCircle,
  Target,
  Brain,
  Calendar,
  Briefcase,
} from "lucide-react";
// import AnimatedServiceCarousel from "../components/AnimatedServiceCards";

export const Home = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header
        image={HomeImage}
        title="Elevate Your Coaching Journey with Us"
        subtitle="Discover exclusive opportunities to connect, grow, and get to lead worldwide coaching initiatives."
        buttontext="Join Us"
      />

      <div
        style={{
          padding: "50px",
          display: "flex",
          flexDirection: "column",
          gap: "50px",
        }}
      >
        <Title
          title="Featured Services"
          center={true}
          subtitle="Our Services"
        />
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            flexWrap: "wrap",
            overflow: "visible",
          }}
        >
          <ServiceCard
            image={"../assets/images/two-happy-busy-middle-aged-600nw-2479065515.webp"}
            title="ICF Level I (ACC) Certification Program"
            caption="Start your coaching journey with the ICF Level 1 (ACC) Certification Program "
            style={{ width: "450px" }}
          />
          <ServiceCard
            image={"../assets/images/istockphoto-1308573996-612x612.jpg"}
            title="ICF Level 2 (PCC) Certification Program"
            caption="Advance your coaching expertise with our ICF Level 2 (PCC) Certification Program"
            style={{ width: "450px" }}
          />
          <ServiceCard
            image={"/assets/images/Services/Ind/icf.webp"}
            title="Executive Coaching"
            caption="Empower senior leaders to navigate complexity, drive impact, and lead with clarity through tailored one-on-one executive coaching."
            style={{ width: "450px" }}
          />
          <ServiceCard
            image={"/assets/images/Services/Ind/leadership.jpg"}
            title="Leadership Development"
            caption="Develop high-potential talent and cultivate future-ready leaders with our transformative leadership coaching and development programs."
            style={{ width: "450px" }}
          />
        </div>
      </div>

      {/* <AnimatedServiceCarousel /> */}

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p style={{ fontSize: "20px", lineHeight: "1.4" }}>
              Step Into Your Power: Transform Your Passion into Purpose with ICF
              Certification!
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade"
            >
              Feeling stuck and unfulfilled? An ICF certification can transform
              your life, giving you the freedom, fulfillment, and financial
              security you deserve. Whether you’re passionate about wellness,
              leadership, career, or personal development coaching, this
              certification lets you build a flexible, impactful business around
              your expertise.
              <br />
              <br />
              Enhance your employability, stand out in any industry, and unlock
              new opportunities - all while helping others achieve their goals.
              Take control of your future and design a life aligned with your
              purpose. Why wait? Start your journey to meaningful change today!
            </p>
            <div>
              <PrimaryButton
                label="Learn More"
                onClick={() => {
                  navigate(`/about`);
                }}
              />
            </div>
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={Book}
              alt={"book opened in two hands"}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade"
          >
            <img
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              src={
                "https://assets.entrepreneur.com/content/3x2/2000/1653573496-shutterstock-1575620530.jpg"
              }
              alt={"book opened in two hands"}
            />
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "10px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p style={{ fontSize: "20px", lineHeight: "1.4" }}>
              Build leaders who drive results — not just manage tasks.
              <br />
              Fuel performance, culture, growth, and leadership that lasts.
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade"
            >
              At CTB, we help professionals and organizations develop
              future-ready leaders through globally recognized programs that
              build real-world skills — not just theory.
              <br />
              <br />
              <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <CheckCircle  color="#127987" /> Develop confident, inspiring leaders who know how to grow others
      </span>
      <br />
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Target color="#127987" /> Turn managers into talent magnets who boost engagement and retention
      </span>
      <br />
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Brain color="#127987" /> Equip teams with powerful tools to think strategically and act decisively
      </span>
      <br />
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Calendar color="#127987" /> Flexible learning options designed for busy professionals
      </span>
      <br />
      <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <Briefcase color="#127987" /> Practical, business-focused training that creates lasting results
      </span>
              <br />
              <br />
              Whether you're building your own leadership path or growing the
              next generation of talent — we’ll help you do it with clarity,
              confidence, and impact.
              <br />
              <br />
              It’s more than a certification — it’s a competitive edge.
            </p>
            {/* <div>
              <PrimaryButton
                label="Learn More"
                onClick={() => {
                  navigate(`/about`);
                }}
              />
            </div> */}
          </div>
        </div>
      </div>

      <div
        style={{
          padding: "50px",
          display: "flex",
          flexDirection: "column",
          gap: "50px",
        }}
      >
        <Title title="Latest Blogs" center={true} subtitle="From the Blogs" />

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "30px",
            flexWrap: "wrap",
            overflow: "visible",
          }}
        >
          {trendingblogs.slice(-2).map((blog, index) => (
            <BlogCard2
              id={blog.id}
              key={index}
              image={blog.image}
              title={blog.title}
              readtime={blog.readtime}
              category={blog.category}
              caption={
                blog.description.length > 150
                  ? `${blog.description.slice(0, 150)}...`
                  : blog.description
              }
            />
          ))}
        </div>
      </div>

      <div
        style={{
          padding: "50px",
          display: "flex",
          flexDirection: "column",
          gap: "50px",
        }}
      >
        <InteractiveTestimonials />
      </div>

      <Parallex
        image={HomeParallex}
        title="Enhance your skills with best courses"
        subtitle="Unlock exclusive opportunities to connect, grow, and get to lead worldwide coaching initiatives."
        // buttontext="Join Us"
        // buttontext2="Learn More"
      >
        <div style={{ display: "flex", gap: "30px" }}>
          <SecondaryButton
            label={"Join Us"}
            onClick={() => {
              navigate(`/pathway`);
            }}
          />
          <OutLineButton
            label={"Learn More"}
            onClick={() => {
              navigate(`/about`);
            }}
          />
        </div>
      </Parallex>

      <div
        style={{
          width: "100%",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <Title
          subtitle={"Trending Ebooks"}
          center={true}
          title={"Latest Ebooks"}
        />
        <div
          style={{
            display: "grid",
            gridTemplateColumns:
              window.innerWidth >= 768 ? "repeat(4, 1fr)" : "repeat(2, 1fr)",
            gap: 20, // No gap between items
            marginTop: "30px",
          }}
        >
          {[
            {
              image:
                "/assets/images/Ebooks/coaching-for-enhanced-social-impact.jpg",
            },
            {
              image: "/assets/images/Ebooks/elements-of-career-success.jpg",
            },
            {
              image:
                "/assets/images/Ebooks/interpersonal-effectiveness-in-coaching.jpg",
            },
            {
              image: "/assets/images/Ebooks/so-you-want-to-be-a-coach.jpg",
            },
          ].map((item, index) => (
            <Link
              to="/ebooks"
              key={index}
              style={{ all: "unset", cursor: "pointer" }}
            >
              <img
                style={{
                  width: "100%",
                  aspectRatio: "6 / 9",
                  objectFit: "cover",
                  display: "block", // Removes any inline spacing
                }}
                src={item.image}
                alt={`ebook-${index}`}
              />
            </Link>
          ))}
        </div>
      </div>

      <div
        style={{
          width: "100%",
          justifyContent: "center",
          display: "flex",
          padding: "50px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap", // Enable wrapping on small screens
            gap: "50px", // Add spacing when items wrap
          }}
        >
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              aspectRatio: "4 / 3",
            }}
            data-aos="fade-up"
          >
            <Link
              to={`/ebooks`}
              style={{ textDecoration: "none", color: "black" }}
            >
              <ServiceCard
                image={Ebooks}
                style={{ width: "100%" }}
                title="Ebook Collection"
                caption={
                  "Welcome to our curated collection of eBooks, each offering a unique perspective on growth, learning, and personal development. Every eBook is a deep dive into a specific journey, packed with insights, experiences, and practical knowledge. Explore our titles to uncover lessons, strategies, and moments of transformation"
                }
              />
            </Link>
          </div>
          <div
            style={{
              flex: "1 1 300px", // Make it responsive: minimum size 300px
              gap: "30px",
              display: "flex",
              flexDirection: "column",
              maxWidth: "100%",
            }}
          >
            <p
              style={{
                fontSize: "40px",
                textAlign: "left",
                lineHeight: "1.2", // Adjust line-height for readability
              }}
              data-aos="fade-up"
            >
              Explore Our Engaging Workshops
            </p>
            <p
              style={{
                fontSize: "16px",
                textAlign: "left",
                lineHeight: "1.6", // Add spacing between lines for readability
              }}
              data-aos="fade-up"
            >
              Join us in our interactive workshops designed to enhance your
              skills and knowledge. Discover a variety of topics, connect with
              like-minded individuals, and dive into hands-on experiences. Check
              out our gallery to see the highlights from our past sessions!
            </p>
            <div data-aos="fade-up">
              <PrimaryButton
                label={"Find Out More"}
                onClick={() => {
                  navigate(`/workshops`);
                }}
              />
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};